"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Others = function Others() {
  return _react2.default.createElement(
    "g",
    { id: "other-circle" },
    _react2.default.createElement("path", { d: "M250 0C112 0 0 111.9 0 250s112 250 250 250c138.1 0 250-111.9 250-250S388.1 0 250 0z", fillRule: "nonzero" }),
    _react2.default.createElement("path", { d: "M186.149 112.657C202.435 102.219 222.485 97 246.237 97c31.216 0 57.127 7.43 77.794 22.288C344.636 134.147 355 156.128 355 185.293c0 17.868-4.504 32.91-13.449 45.13-5.244 7.429-15.3 16.884-30.167 28.427L296.7 270.21c-7.958 6.2-13.326 13.385-15.917 21.674-1.665 5.219-2.529 13.323-2.652 24.314h-56.14c.802-23.21 3.023-39.296 6.6-48.138 3.579-8.841 12.833-19.034 27.639-30.638l15.114-11.728c4.936-3.684 8.946-7.797 11.969-12.157 5.49-7.552 8.266-15.902 8.266-24.928 0-10.438-3.084-19.955-9.192-28.551-6.107-8.596-17.335-12.894-33.56-12.894-15.978 0-27.33 5.28-33.993 15.902-6.662 10.561-9.994 21.613-9.994 32.972H145c1.604-39.234 15.361-66.987 41.149-83.381zM220 344h61.939v59.558H220z", fill: "#FFF" })
  );
};

exports.default = Others;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/OthersCircle.js
// module id = 2973
// module chunks = 4